import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';



@Component({
  selector: 'ejemplo-tablas',
  templateUrl: './ejemplo-tablas.component.html',
  styleUrls: ['./ejemplo-tablas.component.scss']
})
export class EjemploTablasComponent implements OnInit {
  data_ejemplo = [
    {raza:'Yorkshire', nombre:'Eluney', edad:7},
    {raza:'Calle con vereda', nombre:'Tofu', edad:12},
    {raza:'Pseudo Persa', nombre:'Cocotom', edad:1, gato:true},
  ]
  data_replicada = [...this.data_ejemplo]
  columnas = ['raza', 'nombre']
  columnasExt = Object.keys(this.data_ejemplo[0])
  labels=[ 'Raza de animal', 'Se llama', 'Su edad' ]

  extendida = false
  content : any=null
  
  constructor(public modalService: NgbModal) { }

  ngOnInit(): void {
    for (let index = 0; index < 10; index++) {
      this.data_ejemplo.forEach(d => {
        let aux = {raza:d.raza, nombre:d.nombre, edad:d.edad+index, gato:d.gato}
        this.data_replicada.push(aux)
      });
    }
  }
  verTabla(tabla:any){ this.content = tabla}
  extender(){ this.extendida=!this.extendida  }
  

  seleccionado :any=null 
  select(tupla:any,md:any){
    const modal = this.modalService.open(md)
    this.seleccionado = tupla
  }

  todos = false
  lista_chequeable = JSON.parse(JSON.stringify(this.data_ejemplo))
  check(tupla:any=null){  if(tupla){   tupla.check = tupla.check? false : true; this.todos=false   } }
  checkall(res:any[]){
    res.forEach((e:any) => { e.check = !this.todos  });
    this.todos = !this.todos
  }

}
